"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const wait_1 = __importDefault(require("./wait"));
function waitAtLeast(delay) {
    const startTime = +new Date();
    return async function waiting() {
        const now = +new Date();
        const timeDiff = (startTime + delay) - now;
        if (timeDiff < 0) {
            return true;
        }
        await (0, wait_1.default)(timeDiff);
        return true;
    };
}
exports.default = waitAtLeast;
